import { render } from "./Selects.vue?vue&type=template&id=232f1819&scoped=true"
import script from "./Selects.vue?vue&type=script&lang=js"
export * from "./Selects.vue?vue&type=script&lang=js"

import "./Selects.vue?vue&type=style&index=0&id=232f1819&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232f1819"]])

export default __exports__